<template>
  <el-tabs
    v-model="tabsActive"
    :class="b('', {
      'isOverSeas': isOverseasVersion
    })"
  >
    <el-tab-pane
      v-for="fc in functionTypeList"
      :key="fc.value"
      :label="fc.label"
      :name="fc.value"
    >
      <div :class="b('pane-warp')">
        <div :class="b('pane-item')">
          <label :class="b('pane-label')">
            {{ $t('project.overview.formula.dimension') }}
          </label>
          <FormulaCustomPopoverItem
            :params="fc.param"
            @parent-change="handleRadioChange(fc.value, $event, 'object')"
            @child-change="handleRadioChange(fc.value, $event, 'field')"
          />
        </div>

        <div :class="b('pane-item', 'conditions')">
          <label :class="b('pane-label')">
            {{ $t('project.overview.formula.condition') }}
          </label>
          <FormulaCustomPopoverItem
            :params="currentConditionsList"
            :project-id="projectId"
            :request-func="loadConditions"
            @change="handleRadioChange(fc.value, $event, 'conditions')"
          />
        </div>
      </div>

      <div :class="b('footer')">
        <el-button
          :class="b('btn')"
          @click="onCancel"
        >
          {{ $t('button.cancel') }}
        </el-button>
        <el-button
          type="primary"
          :class="b('btn')"
          @click="onSubmit(fc.value)"
        >
          {{ $t('button.confirm') }}
        </el-button>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import FormulaCustomPopoverItem from './FormulaCustomPopoverItem';
import { getFormulaConditionOptions } from 'common-module/src/api/field';

const paramVo = {
  functionType: 'SUM', // 统计函数类型
  object: null, // 统计对象
  objectName: null,
  field: null, // 统计维度字段
  fieldName: null,
  conditions: null, // 统计条件
  conditionCode: null,
  conditionName: null,
  conditionValue: null,
  conditionValueName: null
};
export default {
  name: 'FormulaCustomPopover',
  components: { FormulaCustomPopoverItem },
  props: {
    paramList: {
      type: Array,
      default: () => []
    },
    projectId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      bemNS: theme.bemNS,
      tabsActive: 'SUM',
      functionTypeList: [
        { label: 'SUM', value: 'SUM' },
        { label: 'COUNT', value: 'COUNT' }
      ],
      vo: null
    };
  },
  computed: {
    currentVo() {
      return this.vo[this.tabsActive];
    },
    currentParam() {
      return this.functionTypeList.find(f => f.value === this.tabsActive)?.param || null;
    },
    currentConditionsList() {
      if (!this.currentParam) {
        return [];
      }
      return this.currentParam[this.currentVo.object]?.conditionFields || [];
    }
  },
  watch: {
    paramList(list) {
      this.initParam(list);
    }
  },
  created() {
    this.resetVo(); // 初始化值列表
  },
  methods: {
    async loadConditions(data) {
      return await getFormulaConditionOptions(data);
    },
    initParam(list) {
      const _list = list.map(m => {
        if (m.field){
          return m;
        }
        return { ...m, field: 'count', fieldName: this.$t('resource.issueCount') };
      });
      this.functionTypeList = this.functionTypeList.map(fc => {
        return { ...fc, param: this.transformParam(_list, fc.value) };
      });
    },
    transformParam(list, name) {
      if (!list) {
        return;
      }
      return list.filter(item => item.functionType === name)
        .reduce((prev, cur) => {
          const option = { field: cur.field, fieldName: cur.fieldName };
          prev[cur.object]
            ? prev[cur.object].options.push(option)
            : prev[cur.object] = {
              name: cur.objectName,
              options: [option],
              conditionFields: [
                { fieldCode: null, fieldName: this.$t('project.overview.formula.notLimited') },
                ...cur.conditionFields
              ]
            };
          return prev;
        }, {});
    },
    handleRadioChange(key, val, name) {
      if (name === 'conditions') {
        const { parent = {}, child = {} } = val || {};
        this.$set(this.vo, key, {
          ...this.vo[key],
          [name]: { [parent.value]: child.value },
          conditionCode: parent.value,
          conditionName: parent.label,
          conditionValue: child.value,
          conditionValueName: child.label
        });
        return;
      }
      const { value, label } = val || {};
      this.$set(this.vo, key, {
        ...this.vo[key],
        [name]: value,
        [`${name}Name`]: label
      });
    },
    resetVo() {
      this.vo = {};
      this.functionTypeList.forEach(f => {
        this.$set(this.vo, f.value, { ...paramVo, functionType: f.value });
      });
    },
    onCancel() {
      this.$emit('cancel');
    },
    onSubmit() {
      this.$emit('submit', this.currentVo);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@zk/theme/lib/mixins.scss';

@include b(formula-custom-popover) {
  width: 500px;
  @include m(isOverSeas) {
    ::v-deep {
      .zk-formula-custom-popover-item__develop-plane {
        .zk-formula-custom-popover-item__radio-item {
          width: 150px;
        }
      }
    }
  }
  ::v-deep {
    .el-tabs__item:nth-child(2) {
      padding-left: 32px !important;
    }
    .el-tabs__content{
      min-height: 300px;
    }
    .el-tabs__content {
      .el-tab-pane{
        padding: 10px 32px 0 32px;
      }
    }

    .el-tabs__nav-wrap::after {
      height: 1px;
    }
  }

  @include e(pane-warp) {
    height: 270px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  @include e(pane-label) {
    font-size: var(--size-font-9);
    font-weight: var(--weight-font-Semiblod);
    color: var(--font-color-2);
    margin-bottom: 8px;
    display: block;
  }
  @include e(pane-item) {
    @include m(conditions) {
      margin-top: 20px;
    }
  }
  @include e(footer) {
    padding: 20px 0 10px;
    text-align: right;
  }
}
</style>
